import gql from 'graphql-tag';

export const UNITS_OF_MEASURE = gql`
  query unitsOfMeasure {
    unitsOfMeasure {
      code
      name
    }
  }
`;
